import { Navigate } from "react-router-dom";

export default function AdminProtectedRoute({ children }) {
  const isLoggedIn = localStorage.getItem("admin_logged_in") === "true";

  if (!isLoggedIn) {
    return <Navigate to="/BudgetmateAdmin" replace />;
  }

  return children;
}
